import React from 'react'
import { useSelector } from 'react-redux'
import {
  selectIsChatAvailabilityOpen,
  selectIsPresenceOverviewOpen,
} from 'selectors/modals_base'
import PresenceOverviewModal from 'components/Presence/Overview/Modal'
import AvailabilityEditor from './AvailabilityEditor'

// NOTE (jscheel): Use this component to control rendering of any modals we add
const Modals = () => {
  const showAvailabilityModal = useSelector(selectIsChatAvailabilityOpen)
  const showPresenceOverviewModal = useSelector(selectIsPresenceOverviewOpen)
  return (
    <React.Fragment>
      {showAvailabilityModal && <AvailabilityEditor />}
      {showPresenceOverviewModal && <PresenceOverviewModal />}
    </React.Fragment>
  )
}

export default Modals
